import Rest from '../rest'

/******************************************************************************
 *  Files
 *****************************************************************************/

/**
 * @type {fieldGroupHasField}
 */
export default class FieldGroupHasField extends Rest {

    constructor() {
        super('/fieldgrouphasfield')
    }

    getTeamFields(){
        return this.getAll('team', null)
    }

    /**
     * Busca todos os campos cadastrados no sistema
     *
     * @returns JSON
     */
    getFields() {
        return this.http.get('field').then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }
}